import(/* webpackMode: "eager" */ "/codebuild/output/src2456031874/src/lawgue-website-v2/src/app/(default)/layout.page.tsx")